import placeholderImg from '../images/6.png'


const Teams = [
    {
        id: '1',
        title: 'Dr. Mahinda Jayasooriya',
        subtitle: 'Managing Director',
        slug: 'Mahinda-Jayasooriya',
        timg: placeholderImg,
        Sime: placeholderImg,
    },
    {
        id: '2',
        title: 'Dr. Kumari Perera',
        subtitle: 'Cardiologist',
        slug: 'Kumari-Perera',
        timg: placeholderImg,
        Sime: placeholderImg,
    },
    {
        id: '3',
        title: 'Dr. Anil Fernando',
        subtitle: 'Surgeon',
        slug: 'Anil-Fernando',
        timg: placeholderImg,
        Sime: placeholderImg,
    },
    {
        id: '4',
        title: 'Dr. Nishantha Silva',
        subtitle: 'Orthopedic Specialist',
        slug: 'Nishantha-Silva',
        timg: placeholderImg,
        Sime: placeholderImg,
    },
    {
        id: '5',
        title: 'Dr. Dilani Wickramasinghe',
        subtitle: 'Pediatrician',
        slug: 'Dilani-Wickramasinghe',
        timg: placeholderImg,
        Sime: placeholderImg,
    },
    {
        id: '6',
        title: 'Dr. Ruwan Bandara',
        subtitle: 'Neurologist',
        slug: 'Ruwan-Bandara',
        timg: placeholderImg,
        Sime: placeholderImg,
    },
]

export default Teams;
